import { Controller, type Control, type FieldErrors } from "react-hook-form";
import { MultiSelect } from "primereact/multiselect";
import { Panel } from "primereact/panel";
import { FormField } from "@/components/forms";
import { formStyles } from "@/components/forms/formStyles";
import type { EventFormData } from "@/lib/event-schemas";

export function TagsField(props: {
  control: Control<EventFormData>;
  errors: FieldErrors<EventFormData>;
  availableTags: Array<{ label: string; value: string }>;
}) {
  return (
    <Panel header="Tags">
      <div className="flex flex-column gap-2">
        <FormField
          id="tags"
          label="Tags"
          optional
          error={props.errors.tags?.message}
          helperText="Select existing tags (manage tags in the Tags page)."
        >
          <Controller
            control={props.control}
            name="tags"
            render={({ field }) => {
              const currentTags = Array.isArray(field.value) ? field.value : [];

              // Combine available tags with currently selected tags (e.g. tags loaded from event)
              const allOptions = [...props.availableTags];
              const byValue = new Set(allOptions.map((t) => t.value));
              for (const tag of currentTags) {
                if (!byValue.has(tag)) {
                  allOptions.push({ label: tag, value: tag });
                  byValue.add(tag);
                }
              }

              return (
                <MultiSelect
                  id="tags"
                  value={currentTags}
                  options={allOptions}
                  onChange={(e) => field.onChange(e.value || [])}
                  filter
                  placeholder="Select tags..."
                  className="w-full"
                  style={formStyles.input}
                />
              );
            }}
          />
        </FormField>
      </div>
    </Panel>
  );
}








